module.exports = __webpack_public_path__ + "static/media/cjclogolong.939dadc8.png";